import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import Result from "../views/Result.vue";
import Phase from "../views/Phase.vue";
import Overview from "../views/Overview.vue";
import MultiStepForm from "../views/MultiStepForm.vue";
import Introduction from "../views/Introduction.vue";
import FirstInfos from "../views/FirstInfos.vue";
import QuestionView from "../views/QuestionView.vue";
import QuestionPhase from "../views/QuestionPhase.vue";

const routes = [
    {
        path: "/result",
        component: Result,
        children: [
            { path: "overview", component: Overview },
            { path: "phase/:routeName/", component: Phase }
        ]
    },
    {
        path: "/questions",
        component: QuestionView,
        children: [            
            { path: "page/:routeName/", component: QuestionPhase }
        ]
    },
    {
        path: "/questionOld",
        component: MultiStepForm
    },
    {
        path: "/introductionOld",
        component: Introduction
    },
    {
        path: "/firstInfos",
        component: FirstInfos
    }
];

export default new VueRouter({
    mode: "history",
    base: "/Qbility",
    routes: routes
});
